import React from "react";

const sections = [
  {
    title: "Pressure Measurement",
    // subtitle: "All Standards Traceable to NIST",
    instruments: [
      "Pressure Gauge",
      "Pressure Transmitter",
      "Differential Pressure Transmitter",
      "Digital Pressure Indicator",
      "Pressure Switch",
      "Vacuum Gauge",
      "Compound Gauge",
      "Vacuum Transmitter",
      "Digital Vacuum Indicator",
      "Differential Manometer",
      "Magnehelic Manometer",
      "Well Type Manometer",
      "Inclined Manometer",
    ],
    images: ["img1.png", "img2.png", "img3.png", "img4.png"],
  },
  {
    title: "Valve Calibration",
    instruments: [
      "Control Valve",
      "Pressure Safety Valve (PSV)",
      "Pressure Regulating Valve (PRV)",
    ],
    images: ["img5.png", "img6.png", "img44.png"],
  },
  {
    title: "Temperature Measurement",
    instruments: [
      "RTD Sensor",
      "Dial Temperature Gauge",
      "Glass Thermometer",
      "Temperature Indicator",
      "Temperature Controller",
      "Temperature Recorder",
      "Temperature Scanner",
      "Temperature Transmitter",
      "Temperature Data Logger",
    ],
    images: ["img7.png", "img88.png", "img8.png"],
  },
  {
    title: "Electrical Measurement",
    instruments: ["Ammeter", "Voltmeter", "Resistance", "Frequency"],
    images: ["img31.png"],
  },
  {
    title: "Speed Measurement",
    instruments: [
      "Speed (Stirrer, Motor, Shaft)",
      "Belt Speed",
      "Record Chart Speed",
      "RPM Indicator",
      "Tachometer",
    ],
    images: ["img32.png"],
  },
  {
    title: "Time Measurement",
    instruments: [
      "Timer",
      "Wall Clock",
      "Hour Meter",
      "Stop Watch",
      "Time Totalizer",
    ],
    images: ["img9.png"],
  },
  {
    title: "Humidity Measurement",
    instruments: [
      "Wet & Dry Hygrometer",
      "Digital Hygrometer",
      "Humidity Transmitter",
    ],
    images: ["img10.png"],
  },
  {
    title: "Weight Balance Calibration",
    instruments: [
      "Analytical Weight Balance Upto 220gm",
      "Weight Balance Upto 500 kg",
    ],
    images: ["img11.png"],
  },
  {
    title: "Weight Box Calibration",
    instruments: [
      "Analytical Weight Box Upto 220gm",
      "Loose Weights Upto 100 kg",
    ],
    images: ["img12.png", "img13.png"],
  },
  {
    title: "Flow Calibration",
    instruments: [
      "Water Flowmeter",
      "Flow Transmitter- DP type",
      "Digital Flowmeter",
      "Rotameter",
    ],
    images: ["serv21.png", "serv20.png", "serv22.png"],
  },
  {
    title: "Gas Detector/Analyser Calibration",
    instruments: [
      "O2 Analyzers /Detector Calibration",
      "CO Detector Calibration",
      "Multigas Analyzers/detector Calibration",
    ],
    images: ["serv23.png", "serv24.png"],
  },
  {
    title: "Dimension Calibration",
    instruments: [
      "Vernier Caliper ( Dial/ Digital)",
      "Feeler Gauge",
      "Depth Caliper (Vernier/ Dial/ Digital)",
      "Standard Foils",
      "Height Gauge (Vernier/ Dial/ Digital)",
      "Measuring Scale",
      "External Micrometer (Stick Type) Micrometer Head",
      "Measuring Tape",
      "Internal Micrometer (Stick Type) Head",
      "Cylindrical Setting Master",
      "Depth Micrometer",
      "Sanp Gauge / Gap Gauge",
      "Setting Rod / Extension Rod",
      "Plain Plug Gauge / OD Gauge",
      "Dial Gauge (Plunger Type)",
      "Plain ring Gauge / OD Gauge",
      "Dial Gauge (Lever Type)",
      "Thread plug Gauge / (Effective Diameter)",
      "Bore Gauge (Transmission Movement Only)",
      "Push - Pull Gauge",
      "Dial Thickness Gauge",
      "3-Point Micrometers",
      "Dial Caliper (External Measurement)",
      "Slip Gauge sets, etc.",
      "Dial Caliper ( internal Measurement)",
      "Pycnometers",
    ],
    images: ["map7.jpg","map9.png","map10.jpg","map11.jpg","map12.webp"]
  },
];

const CalibrationInstruments = () => {
  return (
    <section className="bg-gray-100 text-gray-800 py-12 px-4 md:px-12">
      {/* Page Title */}
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold border-b-4 inline-block border-orange-500 pb-2">
          Calibration Instruments
        </h2>
      </div>

      {sections.map((section, idx) => (
        <div
          key={idx}
          className="bg-white shadow-lg rounded-xl p-6 md:p-8 mb-10"
        >
          <div className="flex flex-col md:flex-row gap-8">
            {/* LEFT: Content */}
            <div className="md:w-1/2">
              <h3 className="text-2xl font-bold text-orange-600 flex items-center gap-2 mb-2">
                <span className="text-3xl">❖</span>
                {section.title}
              </h3>
              {section.subtitle && (
                <p className="text-gray-600 font-medium mb-4">
                  {section.subtitle}
                </p>
              )}

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {section.instruments.map((item, i) => (
                  <div
                    key={i}
                    className="flex items-center font-bold border border-orange-200 rounded-lg px-4 py-2 text-sm hover:bg-orange-100 transition shadow-sm"
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT: Image Gallery */}
            {section.images && (
              <div className="md:w-1/2 grid grid-cols-2 gap-4">
                {section.images.map((img, i) => (
                  <div
                    key={i}
                    className="bg-gray-100 p-2 rounded-lg shadow-md hover:scale-105 transform transition duration-300 flex items-center justify-center"
                  >
                    <img
                      src={`./img/service/${img}`}
                      alt={`${section.title} ${i + 1}`}
                      className="w-full h-40 object-contain"
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </section>
  );
};

export default CalibrationInstruments;
